import React, { useState, useEffect } from 'react';
import { head } from 'lodash/fp';
import {
  getBeamAngles,
  getPopulatedBeamAngles,
  getColourTemperatureTitles,
  getColourTemperatureLabels,
  getLitEffects,
} from 'modules/tech-spec';
import { HEADERS } from 'constants/tech-spec';
import PropTypes from 'prop-types';
import styles from './style.module.scss';
import { useSelector } from 'react-redux';
import { SIZE_SMALL } from 'constants/sizes';
import { THEME_DARK } from 'constants/color-theme';
import { Button } from 'components/buttons';
import _ from 'lodash';

export const TechSpec = ({ data }) => {
  const [state, setState] = useState({
    activeColourTemperature: false,
    activeLitEffect: false,
    beamAngles: false,
    populatedBeamAngles: false,
    colourTemperatureTitles: false,
    colourTemperatureLabels: false,
    litEffects: false,
    initialised: false,
  });

  const productPageV2 = useSelector(
    (state) => state.product.data.productPageV2
  );

  const {
    activeColourTemperature,
    activeLitEffect,
    beamAngles,
    populatedBeamAngles,
    colourTemperatureTitles,
    colourTemperatureLabels,
    litEffects,
    initialised,
  } = state;

  const colourTemperatures = data['add_colour_temperature'];

  console.log('acts', colourTemperatures);
  // Initial load
  useEffect(() => {
    const colourTemperatureTitles =
      getColourTemperatureTitles(colourTemperatures);

    const colourTemperatureLabels =
      getColourTemperatureLabels(colourTemperatures);

    console.log('data', data);
    console.log('ct', getColourTemperatureTitles(colourTemperatures));

    const activeColourTemperature = head(colourTemperatureTitles);
    const litEffects = getLitEffects(
      activeColourTemperature,
      colourTemperatures
    );

    console.log('tryy', activeColourTemperature);

    const activeLitEffect = head(litEffects)?.lit_effect;
    const beamAngles = getBeamAngles(activeLitEffect, litEffects);
    const populatedBeamAngles = getPopulatedBeamAngles(beamAngles);

    setState({
      colourTemperatureTitles,
      colourTemperatureLabels,
      litEffects,
      //activeColourTemperature : '3000k',
      activeColourTemperature: colourTemperatures[0].colour_temperature.value,
      activeLitEffect,
      beamAngles,
      populatedBeamAngles,
      initialised: true,
    });
  }, [data, colourTemperatures]);

  const beamHeadings = {
    beam_width_fwhm: '',
    beam_angle: '',
    initial_lumens: 'Source Lumens',
    //engine_lumens: 'Engine Lumens',
    luminaire_lumens: 'Luminaire Lumens',
    peak_intensity: 'Peak Intensity',
    cri: 'CRI',
    r9: 'R9',
    rf_rg: 'Rf/Rg',
    ugr: 'UGR',
    current: 'Current',
    voltage: 'Voltage',
    wattage: 'Wattage',
    circuit_power: 'Circuit Power',
    optical: 'Optical',
    part_l1: 'Part L1',
    part_l2: 'Part L2',
  };
  console.log('act', activeColourTemperature);
  const beamHeadingKeys = Object.keys(beamHeadings);

  const beamTable = !activeColourTemperature
    ? ''
    : beamHeadingKeys.map((heading, index) => {
        /*
        const selectedColourTemp = _.find(colourTemperatures, {
          colour_temperature: activeColourTemperature,
        });

        */

        const selectedColourTemp = _.find(
          colourTemperatures,
          (item) => item?.colour_temperature?.value === activeColourTemperature
        );

        let fullRow = !Boolean(selectedColourTemp)
          ? ''
          : selectedColourTemp['add_lit_effect'].map((beamAngles, index1) => {
              let angleRow = beamAngles.add_beam_angle.map((angle, index2) => {
                let angleName = angle['beam_angle'];
                angleName = angleName.replace(/\s+/g, '_');

                if (index1 === 0 && index2 === 0) {
                  /*
                if(heading === 'beam_angle' || heading === 'beam_width_fwhm'){
                  return (
                    <td></td>
                  )
                } */
                  return (
                    <>
                      <td className={styles['heading-cell']}>
                        <p>{beamHeadings[heading]}</p>
                      </td>
                      <td
                        className={
                          styles[angleName.toLowerCase() + '-cell'] +
                          ' ' +
                          styles[heading + '-cell']
                        }
                      >
                        <p>{angle[heading]}</p>
                      </td>
                    </>
                  );
                } else {
                  return (
                    <td
                      className={
                        styles[angleName.toLowerCase() + '-cell'] +
                        ' ' +
                        styles[heading + '-cell']
                      }
                    >
                      <p>{angle[heading]}</p>
                    </td>
                  );
                }
              });
              return angleRow;
            });
        if (beamHeadingKeys.length === index + 1) {
          if (
            colourTemperatures[0]['add_lit_effect'][0]['add_beam_angle'][0][
              heading
            ] === ''
          ) {
            return '';
          }
          return <tr className={styles['last-row']}>{fullRow}</tr>;
        }
        if (
          colourTemperatures[0]['add_lit_effect'][0]['add_beam_angle'][0][
            heading
          ] === ''
        ) {
          return '';
        }
        return <tr>{fullRow}</tr>;
      });

  // Colour temperature change
  useEffect(() => {
    if (activeColourTemperature !== false) {
      const litEffects = getLitEffects(
        activeColourTemperature,
        colourTemperatures
      );

      console.log('litttty-act', activeColourTemperature);
      console.log('litttty-ct', colourTemperatures);

      console.log('litttty', litEffects);

      const activeLitEffect = head(litEffects)?.lit_effect;
      const beamAngles = getBeamAngles(activeLitEffect, litEffects);
      const populatedBeamAngles = getPopulatedBeamAngles(beamAngles);

      console.log(colourTemperatures[0]['add_lit_effect']);

      setState({
        ...state,
        litEffects,
        activeLitEffect,
        beamAngles,
        populatedBeamAngles,
      });
    }
    // eslint-disable-next-line
  }, [activeColourTemperature]);

  // Lit effect change
  useEffect(() => {
    if (activeLitEffect !== false) {
      const beamAngles = getBeamAngles(activeLitEffect, litEffects);
      const populatedBeamAngles = getPopulatedBeamAngles(beamAngles);

      setState({
        ...state,
        beamAngles,
        populatedBeamAngles,
      });
    }
    // eslint-disable-next-line
  }, [activeLitEffect]);

  // Dont show anything until we have initialised
  if (!initialised) return null;

  const handleChange = (name, value) => {
    setState({
      ...state,
      [name]: value,
    });
  };

  console.log('wun', colourTemperatures);
  console.log('too', colourTemperatureTitles);

  const colourTempButtons = colourTemperatureTitles.map((temp) => {
    console.log('fireee', activeColourTemperature + ' ' + temp);

    let colourTempButton;

    if (temp === activeColourTemperature) {
      colourTempButton = (
        <Button
          stylesClass="active-tech-btn"
          size={SIZE_SMALL}
          theme={THEME_DARK}
          label={colourTemperatureLabels[temp].label}
          key={colourTemperatureLabels[temp].label}
        />
      );
    } else {
      colourTempButton = (
        <Button
          stylesClass="tech-btn"
          size={SIZE_SMALL}
          theme={THEME_DARK}
          label={colourTemperatureLabels[temp].label}
          key={colourTemperatureLabels[temp].label}
        />
      );
    }

    return (
      <span
        onClick={(e) => {
          e.preventDefault();
          handleChange('activeColourTemperature', temp);
        }}
      >
        {colourTempButton}
      </span>
    );
  });

  return (
    <>
      {!productPageV2 && (
        <section className={`${styles['tech-spec']}  section`}>
          <div className="container">
            <div className={styles.inner}>
              <div className={styles['left-column']}>
                <p className={styles['tech-spec-title']}>beam and lumens</p>
                <p className={styles['tech-spec-description']}>
                  Choose the colour temperature and beam angle to suit your
                  scheme. Up to 10 precise beam angles ranging from 'Soft' to
                  'Spot' and 'Speciality'.
                </p>
                <table className={styles['table-left']}>
                  <tbody>
                    {Object.keys(HEADERS).map((key, index) => {
                      if (populatedBeamAngles.indexOf(key) > -1) {
                        return (
                          <tr className={styles['table-row-left']} key={index}>
                            <td className={styles.headers}>
                              <p>{HEADERS[key]}</p>
                            </td>
                          </tr>
                        );
                      }

                      return false;
                    })}
                  </tbody>
                </table>
              </div>
              <div className={styles['right-column']}>
                <div className={styles['colour-temperature-toggle']}>
                  <div className={styles['colour-temperature-container']}>
                    {colourTemperatureTitles.map((title, index) => (
                      <button
                        key={index}
                        className={
                          activeColourTemperature === title ? styles.active : ''
                        }
                        onClick={() =>
                          handleChange('activeColourTemperature', title)
                        }
                      >
                        {title}
                      </button>
                    ))}
                  </div>
                </div>
                <div className={styles['lit-effect-toggle']}>
                  <div className={styles['lit-effect-container']}>
                    {litEffects.map((item, index) => (
                      <button
                        key={index}
                        className={
                          activeLitEffect === item.lit_effect
                            ? styles.active
                            : ''
                        }
                        onClick={() =>
                          handleChange('activeLitEffect', item.lit_effect)
                        }
                      >
                        {item.lit_effect}
                      </button>
                    ))}
                  </div>
                </div>
                <table className={styles['table-right']}>
                  <tbody className={styles.table}>
                    {Object.keys(HEADERS).map((key, index) => {
                      if (populatedBeamAngles.indexOf(key) > -1) {
                        return (
                          <tr className={styles['table-row-right']} key={index}>
                            {beamAngles.map((item, index) => (
                              <td className={styles.values} key={index}>
                                <p>{item[key]}</p>
                              </td>
                            ))}
                          </tr>
                        );
                      }
                      return false;
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      )}
      {productPageV2 && (
        <section className={`${styles['tech-spec']} ${styles['ppv2']} section`}>
          <div>
            <nav className={styles['colour-temp-btns']}>
              {colourTempButtons}
            </nav>
            <table className={styles['beam-table']}>{beamTable}</table>
          </div>
        </section>
      )}
    </>
  );
};

TechSpec.propTypes = {
  data: PropTypes.shape({
    add_colour_temperature: PropTypes.array,
    add_line_drawings: PropTypes.array,
    downloads: PropTypes.object,
    engine_type: PropTypes.object,
    specification_code: PropTypes.object,
  }),
};
